module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Wood2-27598c18ffa2a4d7ff9d63fcdde4a8e6.svg";